/* eslint-disable operator-linebreak */
import React, { useEffect } from 'react'
import dayjs from 'dayjs'
import { swalError } from '../../common/components/Swaler'

import useSWR from '../../hooks/useSWR'
import './Modal.css'

const customStyles = {
  content: {
    position: 'fixed',
    top: '10%',
    left: '12%',
    right: 'auto',
    bottom: 'auto',
    padding: 20,
    zIndex: 9999,
    width: '85%',
    height: '80%',
    backgroundColor: 'white',
    border: '1px solid lightgrey',
  },
}
const ShowBatteryStatusModal = ({ setShowBatteryStatusModal, setLockId, lockId, setChoosenController }) => {
  const { data: controllers, error } = useSWR(`/subject/admin/controllers?search=${lockId}`)
  const handleCloseModal = () => {
    setShowBatteryStatusModal(false)
    setLockId(null)
  }

  const handleQlocxIdClick = (controllerId) => {
    setShowBatteryStatusModal(false)
    setChoosenController(controllerId)
  }

  useEffect(() => {
    if (error) {
      swalError('Fel', error.message)
    }
  }, [error])
  return (
    <div style={customStyles.content}>
      <div style={{ display: 'flex', alignItems: 'end' }}>
        <button onClick={handleCloseModal} style={{ backgroundColor: '#006e78', color: 'white' }}>
          Close
        </button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        {controllers && controllers.length === 0 && <p>Ingen controller hittades för det här låset</p>}
        {controllers &&
          controllers.map((controller) => (
            <div key={controller._id} style={{ border: '1px solid #006e78', maxWidth: '60%', textAlign: 'center', margin: '15px', padding: '5px' }}>
              <h4 style={{ color: '#006e78' }} onClick={() => handleQlocxIdClick(controller.public_key.slice(0, 8))}>
                QlocxId: {controller.public_key.slice(0, 8)} {controller.is_carrier_door_controller && '(transportörsdörr)'}
              </h4>
              <p>Senaste batterivärde: {controller.hardware_functions.get_battery.latest_value}</p>
              <p>Senaste mätning: {dayjs(controller.hardware_functions.get_battery.latest_pull).format('YYYY-MM-DD HH:mm:ss')}</p>
            </div>
          ))}
      </div>
    </div>
  )
}

export default ShowBatteryStatusModal
